import Cookies from 'js-cookie'
import { beginCheckoutFlow } from '@/lib/helpers/cart'
import messages from '@/content/data/error-toasts'
import { useSessionStorage } from '@/lib/helpers/storage'

export default {
  computed: {
    inCheckout() {
      return !!this.$route.query.checkout
    },

    return() {
      return this.$route.query.app_return_path
    },
  },

  mounted() {
    // If we're in checkout, replace the return path from the query
    // Note we also check for an app_return_path so we don't double navigate
    if (this.inCheckout && this.return !== 'cart') {
      const query = { ...this.$route.query, app_return_path: 'cart' }

      this.$router.replace({ query })
    }
  },

  methods: {
    /**
     * Based on the query, decide wether we want to proceed to the checkout
     * or let the component handle it's own auth flow
     */
    handleContinue() {
      if (this.inCheckout) {
        this.beginCheckoutFlow()
      } else {
        this.handleAuth()
      }
    },

    async beginCheckoutFlow() {
      try {
        await beginCheckoutFlow({
          $getAuthInstance: this.$getAuthInstance,
          router: this.$router,
          $api: this.$api,
          store: this.$store,
        })
      } catch (e) {
        this.$sentry.captureException(e)
        this.$toast.error(messages.generic, { duration: null })

        // This should only be running after successful Authentication.
        // Therefore, if something went wrong, it's probably due to the cart.
        // Let's send the user back to /cart to start again. If there's further
        // cart issues they'll be sent to the Editor.
        this.$router.push('/cart')
      }
    },

    async logout() {
      useSessionStorage().removeItem('is_modal_shown')
      Cookies.remove('logo_cart_id')

      const auth = await this.$getAuthInstance()

      try {
        await auth.signOut()
        this.$store.dispatch('logout')
        this.$router.push('/login')
      } catch (e) {
        // Amplify occasionally throws an error if signout takes too long.
        console.log(e)
      }
    },
  },
}
